import React, { useState, useContext, useEffect } from 'react';
import { Box  } from '@mui/material';
import { SymptomDetailsContext } from '../../../utilities/context';
import ExtraFormQuestionsModal from './extra form questions/ExtraFormQuestionsModal';

function TwrRefOptions(props) {
const [pathwaySelected, setPathwaySelected]=useState(false)
const {rdc, setRdc} = useContext(SymptomDetailsContext )
const [modalOpen, setModalOpen] = useState(false)
const [formSubmitted, setFormSubmitted]=useState(false)

const clickFunction=()=>{

  if (!pathwaySelected && !formSubmitted)
    { 
    setModalOpen(true)
    }

  else// code to remove path from list
    {  
      let newRdc= rdc  
      setPathwaySelected(false)
      for( let index = 0; index < rdc.length; index ++)
        { 
        
        if ( newRdc[index] === props.readablePath) 
          { 
            newRdc.splice(index, 1); 
          }
        } 
       setRdc(newRdc)
       setFormSubmitted(false)
    }
  }

useEffect(()=>{
  if (formSubmitted)
    { let newRdc= rdc  
      newRdc.push(props.readablePath)
      setPathwaySelected(true)
      setModalOpen(false)
    }
  },[formSubmitted])//checks that question form has been submitted before completing clinc order

return (  
<>
    <div id="twrOption">
       Refer under {props.readablePath} Two Week Rule Pathway < button id={props.pathway} onClick={clickFunction}>{(pathwaySelected ? "Remove from Order" : "Add to Order")} </button> </div>
       <Box>
       <ExtraFormQuestionsModal path={props.pathway} readablePath={props.readablePath} modalOpen={modalOpen} setModalOpen={setModalOpen} pathwayType={"rdc"} setFormSubmitted={setFormSubmitted}/>
       </Box>
</>
    );
}

export default TwrRefOptions;